<template>
  <div class="flex items-center gap-[10px]">
    <div class="w-[34px] h-[34px]">
      <img src="/assets/images/logo/Avatar_2.png" />
    </div>
    <div class="text-xl bg-blue">
      <span class="font-bold text-white">
        {{ $t("botName") }}
      </span>
    </div>
  </div>
</template>
